const Error =()=>{
    return(
        <p>error</p>
    )
}
export default Error